// Generated by scripts/mdi/import-questionnaires.mjs from MDI "1. NAD+ Initial 6/1/26 09.17.26" (d90a0315-767b-41dc-ac44-1d9bae20faf9). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiNADInitialAnswerField } from './questions';

export const mdiNADInitial: FormType<mdiNADInitialAnswerField> = {
  name: 'NAD+ Initial',
  validityLength: 25,
  questions: [
    {
      key: 'mdiNADInitial_sex',
      next: {
        switch: [
          {
            condition: { 'mdiNADInitial_sex.female': true },
            key: 'mdiNADInitial_pregnantBreastfeeding'
          },
          {
            condition: {
              'mdiNADInitial_pregnantBreastfeeding.currently_pregnant': true
            },
            key: 'mdiNADInitial_urgentDuePregnancyBreastfeedingCannot'
          },
          {
            condition: {
              'mdiNADInitial_pregnantBreastfeeding.currently_breastfeeding':
                true
            },
            key: 'mdiNADInitial_urgentDuePregnancyBreastfeedingCannot'
          },
          {
            condition: {
              'mdiNADInitial_pregnantBreastfeeding.planning_to_become_pregnant_within_90_da':
                true
            },
            key: 'mdiNADInitial_urgentDuePregnancyBreastfeedingCannot'
          }
        ],
        els: 'mdiNADInitial_whyInterestedNadTreatment'
      }
    },
    {
      key: 'mdiNADInitial_pregnantBreastfeeding',
      next: {
        switch: [
          {
            condition: {
              'mdiNADInitial_pregnantBreastfeeding.currently_pregnant': true
            },
            key: 'mdiNADInitial_urgentDuePregnancyBreastfeedingCannot'
          },
          {
            condition: {
              'mdiNADInitial_pregnantBreastfeeding.currently_breastfeeding':
                true
            },
            key: 'mdiNADInitial_urgentDuePregnancyBreastfeedingCannot'
          },
          {
            condition: {
              'mdiNADInitial_pregnantBreastfeeding.planning_to_become_pregnant_within_90_da':
                true
            },
            key: 'mdiNADInitial_urgentDuePregnancyBreastfeedingCannot'
          }
        ],
        els: 'mdiNADInitial_whyInterestedNadTreatment'
      }
    },
    'mdiNADInitial_urgentDuePregnancyBreastfeedingCannot',
    'mdiNADInitial_whyInterestedNadTreatment',
    'mdiNADInitial_activeCancerHistoryCancer',
    'mdiNADInitial_historyAllergicReaction',
    'mdiNADInitial_importantClickAttachedLinkReview',
    'mdiNADInitial_elseLikeTellDoctorWho',
    'mdiNADInitial_complete'
  ]
};
